class BoxSequence {
  constructor() {
      this.init();
  };

  init() {
      fetch('/cart.js', {
          method: 'GET'
      })
          .then(function (response) {
          return response.json();
      })
          .then(async response => {
              this.validateCartAgainstBoxSequences(response);
          })
          .catch(e => {
              console.log(e);
          });
  }

  async validateCartAgainstBoxSequences(cart) {
    try {
        // Start both fetch operations simultaneously
        const fetchPromise1 = fetch('/products/build-box-subscription?view=box-sequence');
        const fetchPromise2 = fetch('/products/hack-pack-subscription?view=hack-sequence');
        const fetchPromise3 = fetch('/products/camp-crunchlabs-weekly-subscription?view=camp-sequence');
        const fetchPromise4 = fetch('/products/creative-kit-subscription?view=creative-kit-sequence');

        // Wait for both fetch operations to complete
        const response1 = await fetchPromise1;
        const response2 = await fetchPromise2;
        const response3 = await fetchPromise3;
        const response4 = await fetchPromise4;

        // Check if the responses are OK and convert to JSON
        const data1 = response1.ok ? await response1.json() : Promise.reject(new Error('Failed to load data from url1'));
        const data2 = response2.ok ? await response2.json() : Promise.reject(new Error('Failed to load data from url2'));
        const data3 = response3.ok ? await response3.json() : Promise.reject(new Error('Failed to load data from url2'));
        const data4 = response4.ok ? await response4.json() : Promise.reject(new Error('Failed to load data from url2'));

        let fetchedData = {...data1.box_sequences, ...data2.box_sequences, ...data3.box_sequences, ...data4.box_sequences}
        try {
          let line = 0;
          cart.items.map(item => {
              line++;
              if (item.properties.box_sequence) {
                  const boxSequences = fetchedData;
                  // const boxSequenceCounters = response.box_sequence_counters;
                  const isBSValid = Object.keys(boxSequences).includes(`${item.properties.box_sequence}`);
                  if (!isBSValid) {
                      const productAndBS = self.getLowestProductAndBoxSequence(
                          boxSequences, boxSequenceCounters
                      );
                      if (productAndBS) {
                          const [product, boxSequence] = productAndBS;
                          const newProperties = {
                              ...item.properties,
                              product_id: `${product.id}`,
                              product_sku: product.sku,
                              product_title: product.title,
                              box_sequence: boxSequence
                          }
                          fetch('/cart/change.js', {
                              method: 'POST',
                              headers: {
                                  'Content-Type': 'application/json',
                              },
                              body: JSON.stringify({
                                  'line': line,
                                  'properties': newProperties
                              })
                          })
                              .then(response => {
                                  return response.json();
                              })
                              .then(() => {
                                  window.location.reload();
                              });
                        }
                  } else {
                      console.log('isBSValid');
                      window.subscriptionFlowCart = {
                          productId: item.properties.product_id,
                          productSKU: item.properties.product_sku,
                          productTitle: item.properties.product_title,
                          boxSequence: item.properties.box_sequence,
                      };
                  }
              }
          });
      } catch (e) {
          console.error(e)
      }
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;  // Rethrow to handle the error externally if necessary
    }
}

  // validateCartAgainstBoxSequences(cart) {
  //     const self = this;
  //     fetch('/products/build-box-subscription?view=box-sequence', {
  //         method: 'GET',
  //         headers: {
  //             'Content-Type': 'application/json',
  //         }
  //     })
  //         .then(response => {
  //             return response.json();
  //         })
  //         .then(response => {
  //             try {
  //                 let line = 0;
  //                 cart.items.map(item => {
  //                     line++;
  //                     if (item.properties.box_sequence) {
  //                         const boxSequences = response.box_sequences;
  //                         const boxSequenceCounters = response.box_sequence_counters;
  //                         const isBSValid = Object.keys(boxSequences).includes(`${item.properties.box_sequence}`);
  //                         if (!isBSValid) {
  //                             const productAndBS = self.getLowestProductAndBoxSequence(
  //                                 boxSequences, boxSequenceCounters
  //                             );
  //                             if (productAndBS) {
  //                                 const [product, boxSequence] = productAndBS;
  //                                 const newProperties = {
  //                                     ...item.properties,
  //                                     product_id: `${product.id}`,
  //                                     product_sku: product.sku,
  //                                     product_title: product.title,
  //                                     box_sequence: boxSequence
  //                                 }
  //                                 fetch('/cart/change.js', {
  //                                     method: 'POST',
  //                                     headers: {
  //                                         'Content-Type': 'application/json',
  //                                     },
  //                                     body: JSON.stringify({
  //                                         'line': line,
  //                                         'properties': newProperties
  //                                     })
  //                                 })
  //                                     .then(response => {
  //                                         return response.json();
  //                                     })
  //                                     .then(() => {
  //                                         window.location.reload();
  //                                     });
  //                               }
  //                         } else {
  //                             console.log('isBSValid');
  //                             window.subscriptionFlowCart = {
  //                                 productId: item.properties.product_id,
  //                                 productSKU: item.properties.product_sku,
  //                                 productTitle: item.properties.product_title,
  //                                 boxSequence: item.properties.box_sequence,
  //                             };
  //                         }
  //                     }
  //                 });
  //             } catch (e) {
  //                 console.error(e)
  //             }
  //         });
  // }

  diffBoxSequence(newSequence, oldSequence) {
      const newCounter = [];
      let hasNew = false;
      newSequence.forEach((collectionId) => {
          if (oldSequence && !Object.hasOwn(oldSequence.counter, parseInt(collectionId))) {
              hasNew = true;
          }
          newCounter[collectionId] = 0;
      });
      const sequenceCounter = {
          sequence: newSequence,
          counter: newCounter,
      };
      if (hasNew || !oldSequence || Object.keys(sequenceCounter.counter).length !== Object.keys(oldSequence.counter).length) {
          return sequenceCounter;
      } else return null;
  };

  getLowestProductAndBoxSequence(boxSequences, boxSequenceCounters) {
      let nextBoxSequence;
      const diff = this.diffBoxSequence(
          Object.keys(boxSequences),
          boxSequenceCounters
      );
      const newSequenceCounter = diff ?? boxSequenceCounters;
      const lowestSequence = Object.entries(newSequenceCounter.counter).sort((a, b) => {
          return a[1] < b[1] ? -1 : 1;
      })[0];
      if (lowestSequence) {
          nextBoxSequence = Number(lowestSequence[0]);
          const products = boxSequences[nextBoxSequence];
          if (products && products.length) {
              return [products[0], nextBoxSequence];
          }
      }
      return null;
  }

  async getBoxSequenceProperties() {
      return new Promise(function(resolve) {
          fetch('/products/build-box-subscription?view=box-sequence', {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
              }
          }).then(response => {
              return response.json();
          }).then(response => {
              try {
                  const boxSequences = response.box_sequences;
                  const boxSequenceCounters = response.box_sequence_counters;
                  if (boxSequences) {
                      const productAndBS = window.boxSequenceApi.getLowestProductAndBoxSequence(
                          boxSequences, boxSequenceCounters
                      );
                      if (productAndBS) {
                          const [product, boxSequence] = productAndBS;
                          resolve( {
                              productId: `${product.id}`,
                              productSKU: product.sku,
                              productTitle: product.title,
                              boxSequence: boxSequence,
                          });
                      }
                  }
              } catch (e) {
                  console.error(e)
              }
          });
      });
  }
  
  async getHackSequenceProperties() {
      return new Promise(function(resolve) {
          fetch('/products/hack-pack-subscription?view=hack-sequence', {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
              }
          }).then(response => {
              return response.json();
          }).then(response => {
              try {
                  const boxSequences = response.box_sequences;
                  const boxSequenceCounters = response.box_sequence_counters;
                  if (boxSequences) {
                      const productAndBS = window.boxSequenceApi.getLowestProductAndBoxSequence(
                          boxSequences, boxSequenceCounters
                      );
                      if (productAndBS) {
                          const [product, boxSequence] = productAndBS;
                          resolve( {
                              productId: `${product.id}`,
                              productSKU: product.sku,
                              productTitle: product.title,
                              boxSequence: boxSequence,
                          });
                      }
                  }
              } catch (e) {
                  console.error(e)
              }
          });
      });
  }

  async getCreativeSequenceProperties() {
      return new Promise(function(resolve) {
          fetch('/products/creative-kit-subscription?view=creative-kit-sequence', {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
              }
          }).then(response => {
              return response.json();
          }).then(response => {
              try {
                const boxSequences = response.box_sequences;
                const boxSequenceCounters = response.box_sequence_counters;
                  if (boxSequences) {
                      const productAndBS = window.boxSequenceApi.getLowestProductAndBoxSequence(
                          boxSequences, boxSequenceCounters
                      );

                      if (productAndBS) {
                          const [product, boxSequence] = productAndBS;
                          resolve( {
                              productId: `${product.id}`,
                              productSKU: product.sku,
                              productTitle: product.title,
                              boxSequence: boxSequence,
                          });
                      }
                  }
              } catch (e) {
                  console.error(e)
              }
          });
      });
  }

  async getCampSequenceProperties() {
      return new Promise(function(resolve) {
          fetch('/products/camp-crunchlabs-weekly-subscription?view=camp-sequence', {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
              }
          }).then(response => {
              return response.json();
          }).then(response => {
              try {
                  const boxSequences = response.box_sequences;
                  const boxSequenceCounters = response.box_sequence_counters;
                  if (boxSequences) {
                      const productAndBS = window.boxSequenceApi.getLowestProductAndBoxSequence(
                          boxSequences, boxSequenceCounters
                      );
                      if (productAndBS) {
                          const [product, boxSequence] = productAndBS;
                          resolve( {
                              productId: `${product.id}`,
                              productSKU: product.sku,
                              productTitle: product.title,
                              boxSequence: boxSequence,
                          });
                      }
                  }
              } catch (e) {
                  console.error(e)
              }
          });
      });
  }
}

window.boxSequenceApi = new BoxSequence();